import { CircleCheck, CircleDashed, TriangleAlert } from 'lucide-react';
import type { HasLibraryCue } from '../lib/cueBadge';
import { cueNumLabel } from '../lib/cueBadge';
import { confirmKind, confirmLabel, confirmTitle } from '../lib/cueConfirm';
import Icon from './Icon';
import './CueNumBadge.css';

const CONFIRM_ICON = { confirmed: CircleCheck, pending: CircleDashed, returned: TriangleAlert } as const;

/**
 * Cue 庫編號小徽章；舊模式專案（沒有編號）什麼都不畫。
 * Cue 庫專案多一個確認標記（導演確認陣形）：已確認 = 打勾的圓、待確認 = 虛線圓、確認後被改過退回 = 警示三角
 * （形狀不同，不只靠顏色分；後台沒給 confirm 的舊版 = 不畫）
 */
export function CueNumBadge({ cue }: { cue: Pick<HasLibraryCue, 'libraryCue'> }) {
  const label = cueNumLabel(cue);
  if (!label) return null;
  const kind = confirmKind(cue.libraryCue);
  if (!kind) return <span className="cue-num-badge" title={`Cue 庫編號 ${label}`}>{label}</span>;
  return (
    <span className={`cue-num-badge cue-num-badge--${kind}`} title={`Cue 庫編號 ${label} · ${confirmTitle(cue.libraryCue)}`} data-confirm={kind}>
      <Icon icon={CONFIRM_ICON[kind]} size="xs" label={confirmLabel(kind)} />
      <span className="cue-num-badge__text">{label}</span>
    </span>
  );
}
